export default {
  homepageNews: {
    loading: false,
    loaded: false,
    data: [],
  },
  news: {
    loading: false,
    loaded: false,
    data: [],
  },
  lastestNews: {
    loading: false,
    loaded: false,
    data: [],
  },
  tags: {
    loading: false,
    loaded: false,
    data: [],
  },
  newsDetails: {
    loading: false,
    loaded: false,
    data: {}
  }
};
